import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "flag-icons-hu",
  viewBox: "0 0 640 480"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "fill-rule": "evenodd" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    d: "M640 480H0V0h640z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#388d00",
    d: "M640 480H0V320h640z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#d43516",
    d: "M640 160.1H0V.1h640z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }